import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import CompanySidebar from './CompanySidebar';
import { Button } from '../ui/button';
import { Menu, X } from 'lucide-react';
import { companyAPI } from '../../lib/api';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from '../ui/sheet';
import { cn } from '../../lib/utils';

const CompanyLayout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await companyAPI.getCurrent();
        setCompany(response.data);
      } catch (error) {
        console.error('Failed to fetch company info:', error);
      }
    };
    fetchCompany();
  }, []);

  const getLogoUrl = (logoPath) => {
    if (!logoPath) return null;
    if (logoPath.startsWith('http')) return logoPath;
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
    return `${backendUrl}${logoPath}`;
  };

  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Mobile Header with Radix Sheet */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-white border-b border-border h-14 flex items-center justify-between px-4">
        <div className="flex items-center gap-2">
          {company?.logo ? (
            <img
              src={getLogoUrl(company.logo)}
              alt={company.name}
              className="h-9 w-auto object-contain"
            />
          ) : (
            <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
              <span className="text-primary-foreground font-bold text-sm">
                {company?.name ? company.name.substring(0, 2).toUpperCase() : 'HR'}
              </span>
            </div>
          )}
        </div>

        <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
          <SheetTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-10 w-10"
            >
              <Menu className="h-5 w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="p-0 w-64 border-none bg-[#0a0a0a] ring-0 outline-none" hideClose>
            <CompanySidebar
              mobile
              onMobileClose={() => setMobileMenuOpen(false)}
              company={company}
            />
          </SheetContent>
        </Sheet>
      </div>

      {/* Sidebar Wrapper */}
      {!mobileMenuOpen && (
        <div className={cn(
          "hidden lg:block h-screen sticky top-0 transition-all duration-300",
          sidebarCollapsed ? "w-[70px]" : "w-[280px]"
        )}>
          <CompanySidebar
            company={company}
            collapsed={sidebarCollapsed}
            setCollapsed={setSidebarCollapsed}
          />
        </div>
      )}

      {/* Main Content Area */}
      <main className="flex-1 min-h-screen lg:pt-0 pt-14 flex flex-col overflow-x-hidden">
        <div className="p-4 sm:p-6 lg:p-8 flex-1">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default CompanyLayout;
